import { formatDuration, type SeriesSet } from '@lms/charts';
import { Tooltip, TooltipContent, TooltipTrigger } from '@lms/ui/tooltip';

/**
 * Total time spent, compact ("342h"); hovering lists the total per
 * curriculum with its series colour.
 */
export function EducationTotal({
  totals,
  seriesSet,
  locale,
}: {
  totals: readonly { curriculumName: string; seconds: number }[];
  seriesSet: SeriesSet;
  locale: string;
}) {
  const sum = totals.reduce((acc, t) => acc + t.seconds, 0);
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          // biome-ignore lint/a11y/noNoninteractiveTabindex: focus shows the breakdown
          tabIndex={0}
          className="decoration-muted-foreground/40 cursor-help underline decoration-dotted underline-offset-4"
        >
          {formatDuration(sum, locale)}
        </span>
      </TooltipTrigger>
      {totals.length > 0 && (
        <TooltipContent align="end" className="max-w-80">
          <ul className="flex flex-col gap-1">
            {totals.map((t) => (
              <li key={t.curriculumName} className="flex items-center gap-1.5">
                <span
                  aria-hidden
                  className="size-2 shrink-0 rounded-full"
                  style={{
                    backgroundColor: seriesSet.get(t.curriculumName).color,
                  }}
                />
                <span className="min-w-0 flex-1 break-words">
                  {t.curriculumName}
                </span>
                <span className="ml-3 font-medium tabular-nums">
                  {formatDuration(t.seconds, locale)}
                </span>
              </li>
            ))}
          </ul>
        </TooltipContent>
      )}
    </Tooltip>
  );
}
